import { SaleExportProp } from 'gen/ApiClient';
import { IStrings } from 'localization/IStrings';

export const createExportRecord = (strings: IStrings): Record<SaleExportProp, string> => {
	return {
		Id: strings.uniqueReference,
		Created: strings.createdAt,
		LastUpdated: strings.lastUpdated,
		AmountPaid: strings.amountPaid,
		CountItems: `# ${strings.items}`,
		HasOutstandingBalance: `${strings.outstandingBalance}?`,
		IsCashSale: `${strings.cashSale}?`,
		IsOverDue: `${strings.overdue}?`,
		IsInvoice: `${strings.invoice}?`,
		IsFullyPaid: `${strings.fullyPaid}?`,
		IsPartlyPaid: `${strings.partlyPaid}?`,
		OutstandingBalance: strings.outstandingBalance,
		PriceExVat: strings.priceExVat,
		PriceInVat: strings.priceInVat,
		RecipientName: strings.withRespectToShort,
		Reference: strings.reference,
		ValidUntil: strings.validTo,
		VatAmount: strings.vatAmount,
		ExternalReference: strings.externalReference,
		LocationIdentifier: strings.location,
		DefaultBelgianStructuredCreditorReference: strings.structuredReference,
		RecipientAddressLine: strings.recipient + ' ' + strings.address,
		RecipientCity: strings.recipient + ' ' + strings.city,
		RecipientCountry: strings.recipient + ' ' + strings.country,
		RecipientZip: strings.recipient + ' ' + strings.zip,
		PatientReference: `${strings.number} ${strings.patient}`,
		Vat0AmountExVat: `${strings.priceExVat} @ 0% ${strings.vat}`,
		Vat0AmountInVat: `${strings.priceInVat} @ 0% ${strings.vat}`,
		Vat0VatAmount: `${strings.vatAmount} @ 0% ${strings.vat}`,
		Vat6AmountExVat: `${strings.priceExVat} @ 6% ${strings.vat}`,
		Vat6AmountInVat: `${strings.priceInVat} @ 6% ${strings.vat}`,
		Vat6VatAmount: `${strings.vatAmount} @ 6% ${strings.vat}`,
		Vat9AmountExVat: `${strings.priceExVat} @ 9% ${strings.vat}`,
		Vat9AmountInVat: `${strings.priceInVat} @ 9% ${strings.vat}`,
		Vat9VatAmount: `${strings.vatAmount} @ 9% ${strings.vat}`,
		Vat12AmountExVat: `${strings.priceExVat} @ 12% ${strings.vat}`,
		Vat12AmountInVat: `${strings.priceInVat} @ 12% ${strings.vat}`,
		Vat12VatAmount: `${strings.vatAmount} @ 12% ${strings.vat}`,
		Vat21AmountExVat: `${strings.priceExVat} @ 21% ${strings.vat}`,
		Vat21AmountInVat: `${strings.priceInVat} @ 21% ${strings.vat}`,
		Vat21VatAmount: `${strings.vatAmount} @ 21% ${strings.vat}`,
	};
};
